<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="false"
  [showHeader]="false"
  [dismissableMask]="false"
  [resizable]="false"
  [draggable]="false"
  styleClass="about-dialog"
  [style]="{ width: '520px' }"
>

  <div class="about-dialog__header">
    <img
      src="assets/images/about-img.jpg"
      alt="Sinergial Advance"
      class="about-dialog__banner"
    />
  </div>

  <div class="about-dialog__body">
    <div
      class="about-dialog__version-badge"
      [class.about-dialog__version-badge--dev]="isDev"
    >
      <span>Versión {{ appVersion }} ({{ informationalVersion }})</span>
    </div>

    <section class="about-dialog__section">
      <strong class="about-dialog__app-name">
        Sinergial Advance &mdash; Gestión de procesos de negocios
      </strong>
      <p class="about-dialog__legal">
        Advertencia: Este programa está protegido por las leyes de derechos de
        autor y tratados internacionales. La reproducción o distribución ilícitas
        de este programa o de cualquier parte del mismo están penadas por la ley
        con severas sanciones civiles y penales y serán objeto de todas las
        acciones judiciales que correspondan.
      </p>
    </section>

    @if (licencia) {
      <div class="about-dialog__license">
        <strong>Nro. de licencia: {{ licencia }}</strong>
      </div>
    }

    <footer class="about-dialog__footer">
      <div class="about-dialog__social">
        <a
          href="https://www.facebook.com/Oliverinformatica/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Facebook Oliver Informática"
          class="about-dialog__social-link"
        >
          <i class="pi pi-facebook"></i>
        </a>
        <a
          href="https://www.instagram.com/oliverinformatica/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram Oliver Informática"
          class="about-dialog__social-link"
        >
          <i class="pi pi-instagram"></i>
        </a>
        <a
          href="https://www.linkedin.com/company/oliver-inform%C3%A1tica/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="LinkedIn Oliver Informática"
          class="about-dialog__social-link"
        >
          <i class="pi pi-linkedin"></i>
        </a>
      </div>

      <div class="about-dialog__support">
        <a
          href="https://wa.me/5493585175140"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="WhatsApp Comercial"
          class="about-dialog__support-link"
        >
          <i class="pi pi-whatsapp"></i>
          Comercial
        </a>
        <a
          href="https://wa.me/5493585091929"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="WhatsApp HelpDesk"
          class="about-dialog__support-link"
        >
          <i class="pi pi-whatsapp"></i>
          HelpDesk
        </a>
      </div>

      <p class="about-dialog__copyright">
        <a
          href="https://www.oliver.ar/"
          target="_blank"
          rel="noopener noreferrer"
          class="about-dialog__site-link"
        >
          www.oliver.ar
        </a>
        &nbsp;|&nbsp;© 2024.
      </p>
    </footer>
  </div>

  <ng-template pTemplate="footer">
    <div class="about-dialog__actions">
      <button type="button" class="btn btn-secondary" (click)="close()">
        Salir
      </button>
    </div>
  </ng-template>
</p-dialog>
